import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { BorrowerTab } from 'app/store/global-borrower-tabs/borrower-tab';
import { GlobalBorrowerTabClose, GlobalBorrowerTabsCloseAll } from 'app/store/global-borrower-tabs/global-borrower-tabs.actions';
import { GlobalBorrowerTabsState } from 'app/store/global-borrower-tabs/global-borrower-tabs.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { CloseTabsDialogComponent } from 'ng2-app/global-borrower-tabs/global-borrower-tabs-smart/close-tabs-dialog.component';

@Component({
  selector: 'app-global-borrower-tabs-smart',
  templateUrl: './global-borrower-tabs-smart.component.html',
  styleUrls: ['./global-borrower-tabs-smart.component.scss'],
  standalone: false
})
export class GlobalBorrowerTabsSmartComponent implements OnDestroy {
  tabs$: Observable<BorrowerTab[]> = this.store.select(GlobalBorrowerTabsState.tabs);
  activeTab$: Observable<BorrowerTab | null> = this.store.select(GlobalBorrowerTabsState.activeTab);
  destroyed$ = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    private store: Store
  ) { }

  openConfirmCloseDialog() {
    const dialogRef = this.dialog.open(CloseTabsDialogComponent, {
      width: '300px'
    });

    // wire up confirm
    dialogRef.componentInstance.confirm.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(() => {
      dialogRef.close();
      this.handleCloseAllTabs();
    });
  }

  handleCloseTab(tab: BorrowerTab, event?: MouseEvent) {
    // The close icon renders inside the tab's own <a routerLink>. RouterLink navigates from its
    // click listener rather than the anchor's default action, so preventDefault alone does not
    // stop it: the click bubbles, RouterLink routes to the tab being closed, and the borrower
    // page re-adds the tab. The click must stop here.
    event?.preventDefault();
    event?.stopPropagation();
    this.store.dispatch(new GlobalBorrowerTabClose(tab.tabId));
  }

  handleCloseAllTabs() {
    this.store.dispatch(new GlobalBorrowerTabsCloseAll());
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }
}
